import React from 'react'
import { Button, Slider, Popover } from 'antd'

const Component = (props) => {
  const [percent, setPercent] = React.useState(100)
  const scale = percent / 100 + 0.0001

  const marks = {
    50: '50%',
    100: '100%',
    150: '150%',
    200: '200%'
  }
  const content = (
    <Slider
      className="slider-progress"
      marks={marks}
      value={percent}
      max={200}
      min={1}
      tooltipVisible={false}
      onChange={setPercent} />
  )

  const strStyle = `.dashboard-theme-dafault{
    width: 100%;
    height: 100%;
    transform-origin: '50% 0 0'; 
    transform: scale(${scale})
  }`

  return (
    <>
      <Popover placement="bottom" content={content} trigger="click">
        <Button>缩放</Button>
      </Popover>
      <style data-type='dashboard_zoom'>{strStyle}</style>
    </>
  )
}

const ScaleButton = {
  title: '画面缩放按钮',
  category: '页面元素',
  component: Component,
  icon: require('./../icon/画面缩放按钮.svg'),
  paramSchema: {},
  initLayout: { width: 100, height: 32 }
}

export default ScaleButton